import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  categoryFieldManual: {
    '& .MuiOutlinedInput-root': {
      flexWrap: 'wrap',
      padding: theme.spacing(0.75, 8, 0.75, 0.75)
    },
    '& input': {
      display: 'none'
    }
  },
  placeholderSelectorContainer: {
    padding: theme.spacing(0.5)
  },
  placeholderSelectorText: {
    color: theme.palette.grey[500]
  }
}));
